module.exports = __webpack_public_path__ + "img/quest_icon_0028_team.685ddf64.png";